<template>
  <div>
    <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab class="tab-default" :key="1"> Học sinh</v-tab>
      <v-tab class="tab-default" :key="2"> Phụ huynh </v-tab>
      <v-tab class="tab-default" :key="3"> Giáo viên </v-tab>
      <v-tab class="tab-default" :key="4"> Thống kê báo cáo </v-tab>
    </v-tabs>

    <v-card :flat="$vuetify.breakpoint.smAndDown">
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1">
          <v-card>
            <div class="d-flex justify-end align-center">
              <!-- <v-btn class="mt-4 ml-4" outlined color="primary" @click="showStudyGroupDialog = !showStudyGroupDialog">
                Sắp xếp nhóm học tập
              </v-btn> -->
              <v-btn
                v-if="$vuetify.breakpoint.mdAndUp"
                class="mt-4 mr-4"
                outlined
                color="success"
                @click="exportExcel('STUDENT_TABLE')"
              >
                <v-icon left>mdi-file-excel</v-icon> Xuất Excel
              </v-btn>
            </div>
            <StudentTable disableSort mobile-breakpoint="0" ref="studentTable" />
          </v-card>
        </v-tab-item>
        <v-tab-item :key="2">
          <v-card>
            <div class="d-flex justify-end align-end">
              <v-btn
                v-if="$vuetify.breakpoint.mdAndUp"
                class="mt-4 mr-4"
                outlined
                color="success"
                @click="exportExcel('PARENT_TABLE')"
              >
                <v-icon left>mdi-file-excel</v-icon> Xuất Excel
              </v-btn>
            </div>
            <ParentDataTable disableSort mobile-breakpoint="0" ref="parentDataTable" />
          </v-card>
        </v-tab-item>
        <v-tab-item :key="3">
          <div>
            <v-card outlined class="ma-8 pa-5">
              <h4>Giáo viên chủ nhiệm</h4>
              <CardOwnClassTeacherInfo
                v-for="(value, index) in classData.headTeachers"
                :ownClassTeacher="value"
                :key="index"
              />
            </v-card>
            <div class="d-flex justify-space-between align-center ma-8">
              <h3>Giáo viên bộ môn</h3>
              <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel('TEACHER_TABLE')">
                <v-icon left>mdi-file-excel</v-icon> Xuất Excel
              </v-btn>
            </div>
            <v-card class="ma-8" outlined>
              <TeacherTable disableSort mobile-breakpoint="0" ref="teacherTable" />
            </v-card>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- <StudyGroupDialog :state="showStudyGroupDialog" /> -->
  </div>
</template>

<script>
import StudentTable from '@/modules/class/student/StudentTable.vue'
import TeacherTable from '@/modules/class/teacher/TeacherTable.vue'
import ParentDataTable from '@/modules/class/ParentDataTable.vue'
import CardOwnClassTeacherInfo from '@/components/basic/card/CardOwnClassTeacherInfo.vue'
import { mapGetters, mapState } from 'vuex'
import utils from '@/plugins/utils'
// import StudyGroupDialog from '@/modules/class/student/StudyGroupDialog.vue'

export default {
  data() {
    return {
      tab: null,
      showStudyGroupDialog: false
    }
  },
  components: {
    CardOwnClassTeacherInfo,
    StudentTable,
    ParentDataTable,
    TeacherTable
    // StudyGroupDialog
  },
  methods: {
    exportExcel(tableName) {
      this.$loading.active = true
      const filters = this.$options.filters
      const students = JSON.parse(JSON.stringify(this.students.filter(s => s.status === 'active')))
      let excelHeader, fileName, data
      switch (tableName) {
        case 'STUDENT_TABLE':
          let studentHeaders = [...this.$refs.studentTable.headers]
          studentHeaders.shift()
          studentHeaders.splice(1, 0, {
            text: 'Mã số',
            value: 'code'
          })
          excelHeader = studentHeaders.map(({ text, value }) => ({ text, value }))
          data = students.map((item, index) => {
            item.code = filters.getStudentCode(item.code)
            item.status = filters.status(item.status)
            item.dob = filters.ddmmyyyy(item.dob)
            item.gender = filters.gender(item.gender)
            return item
          })
          fileName = `DanhSachHocSinh_${this.classData.title}`
          break
        case 'PARENT_TABLE':
          let parentHeaders = [...this.$refs.parentDataTable.headers]
          parentHeaders.shift()
          parentHeaders.splice(1, 0, {
            text: 'Mã số',
            value: 'code'
          })
          excelHeader = parentHeaders.map(({ text, value }) => ({ text, value }))
          data = students.map(item => {
            item.code = filters.getStudentCode(item.code)
            item.dob = filters.ddmmyyyy(item.dob)
            return item
          })
          fileName = `DanhSachPhuHuynh_${this.classData.title}`
          break
        case 'TEACHER_TABLE':
          excelHeader = this.$refs.teacherTable.headers.map(({ text, value }) => ({ text, value }))
          data = this.teachings
          fileName = `GiaoVienBoMon_${this.classData.title}`
          break
      }
      utils.exportExcel(data, excelHeader, fileName)
      this.$loading.active = false
    }
  },
  computed: { ...mapGetters('classDetail', ['students', 'classData']), ...mapState('classDetail', ['teachings']) }
}
</script>

<style></style>
